import { useSelector } from 'react-redux';

import { isManualSkuVenue } from 'helpers/ia-logic';
import { selectActiveVenue } from 'selectors/general';

const INTEGRATION_DISPLAY_NAMES = {
  SQUARE_PRODUCT: 'Square',
};

const useSkuVenuePermissions = () => {
  const venue = useSelector(selectActiveVenue);
  const isManual = isManualSkuVenue(venue);

  return {
    canAddItem: isManual,
    canEditItem: isManual,
    canAddCategory: isManual,
    canEditCategory: isManual,
    canAddMenu: isManual,
    canEditMenu: isManual,
    isManual,
    isIntegrated: !isManual,
    integrationName: INTEGRATION_DISPLAY_NAMES[venue?.venueSource] || '',
  };
};

export default useSkuVenuePermissions;
